const STYLES = {
  Registered: "bg-sky-500/15 text-sky-700 border-sky-500/40",
  "Under Review": "bg-blue-500/15 text-blue-700 border-blue-500/40",
  "Invoice Sent": "bg-violet-500/15 text-violet-700 border-violet-500/40",
  "Payment Confirmed": "bg-teal-500/15 text-teal-700 border-teal-500/40",
  "Carrier Booked": "bg-amber-500/15 text-amber-800 border-amber-500/40",
  Dispatched: "bg-orange-500/15 text-orange-700 border-orange-500/40",
  "In Transit": "bg-amber-500/20 text-amber-800 border-amber-500/60",
  Delivered: "bg-emerald-500/15 text-emerald-700 border-emerald-500/50",
  Cancelled: "bg-red-500/15 text-red-700 border-red-500/50",
};

export const StatusBadge = ({ status, testid = "status-badge" }) => (
  <span className={`inline-flex items-center gap-2 px-3 py-1.5 border font-mono text-xs uppercase tracking-[0.15em] ${STYLES[status] || STYLES.Registered}`} data-testid={testid}>
    <span className="w-1.5 h-1.5 rounded-full bg-current" />{status}
  </span>
);
